module.exports = __webpack_public_path__ + "media/images/note-6b44a17f5c5af01495a530a99a7ec5aa.png";